export default "__VITE_ASSET__b851d0f2__"